import { AiOutlineQuestionCircle } from 'react-icons/ai';
import { AssistantControllerBaseConfig } from '../../../base';
import { AssistantLayoutController } from './interviewLayoutInterface';
import {
    GoSidebarCollapse,
    GoSidebarExpand,
    GoGear,
    GoGitBranch,
    GoCommit,
} from 'react-icons/go';
import {
    AssistantLayoutContainerProps,
    AssistantLayoutViewProps,
} from './interviewLayoutProps';

export function createAssistantLayoutController(
    config: AssistantControllerBaseConfig
): AssistantLayoutController {
    const {
        navigation,
        kernel: {
            controller,
            adapter: { help },
        },
    } = config;
    return {
        useProps(
            context,
            item,
            props
        ): Omit<
            Exclude<AssistantLayoutViewProps, keyof AssistantLayoutContainerProps>,
            'children'
        > {
            const browser = controller.browser.useProps({});
            const navigation = controller.navigation.useProps(props.navigation);
            return {
                isScrollable: props.isScrollable ?? true,
                browser,
                detail: {
                    container: {
                        isVisible: props.detail.value,
                    },
                    button: {
                        onClick: props.detail.onChange.bind(null, !props.detail.value),
                    },
                },
                actions: [
                    // {
                    //     kind: 'button',
                    //     id: 'details',
                    //     label: 'Details',
                    //     Icon: props.detail.value ? GoSidebarCollapse : GoSidebarExpand,
                    //     button: {
                    //         onClick: props.detail.onChange.bind(
                    //             null,
                    //             !props.detail.value
                    //         ),
                    //     },
                    // },
                    // {
                    //     kind: 'button',
                    //     id: 'help',
                    //     label: 'Help',
                    //     Icon: AiOutlineQuestionCircle,
                    //     button: {
                    //         onClick() {
                    //             help.open();
                    //         },
                    //     },
                    // },
                    {
                        id: 'settings',
                        kind: 'menu',
                        label: 'Settings',
                        Icon: GoGear,
                        menu: {
                            header: {
                                label: 'Options',
                            },
                            popover: {
                                ...props.disclosure.settings,
                            },
                            items: [
                                {
                                    kind: 'action',
                                    label: 'Version',
                                    Icon: GoCommit,
                                    action: {
                                        kind: 'select',
                                        options: props.promptVersion.options,
                                        select: {
                                            value: props.promptVersion.value,
                                            onChange(event) {
                                                props.promptVersion.onChange(
                                                    event.target.value as
                                                        | 'active'
                                                        | 'preview'
                                                        | 'develop'
                                                );
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                    },
                ],
                back:
                    // Dont show back button on root page
                    config.navigation.home.path === props.navigation.location.pathname
                        ? null
                        : {
                              button: {
                                  onClick: () => {
                                      props.onBack();
                                  },
                              },
                          },
                link: {
                    home: { to: config.navigation.home.path },
                },
            };
        },
    };
}
